import axios, { AxiosResponse, CancelTokenSource, AxiosRequestConfig } from 'axios'
import { getPhpToken } from 'src/pc/utils/auth'

const { CancelToken } = axios

/**
 * 获取渠道
 */
const GetChannel = () => {
  const recordUrl = localStorage.getItem('firstUrl')
  const finalLocation = recordUrl ? new URL(recordUrl) : window.location
  /*通过域名获取渠道*/
  const HostChannel = finalLocation.host.substr(0, finalLocation.host.indexOf('.'))
  /*通过 URL 查询字段获取渠道*/
  const Query = new URLSearchParams(finalLocation.search.substr(1, finalLocation.search.length))
  return Query.get('channel') || HostChannel
}

interface HttpOptions {
  Url: string
  Type: 'Get' | 'Post'
  OnError?(error: Error): void
}

const BaseHttp = <P, R>(Options: HttpOptions) => {
  let Source: CancelTokenSource
  /**
   * 执行Http操作
   */
  const Execute = async (Params?: P, config?: AxiosRequestConfig): Promise<R> => {
    Source = CancelToken.source()
    //添加Authorization请求头
    const cfg = {
      ...{
        headers: {
          ...(getPhpToken() ? { Authorization: getPhpToken() } : {}),
          ...(GetChannel() ? { channel: GetChannel() } : {}),
          ...config?.headers,
        },
      },
      ...config,
    }
    try {
      if (Options.Type === 'Get') {
        return await HttpGet(Options.Url, Params, cfg)
      }
      return await HttpPost(Options.Url, Params, cfg)
    } catch (err) {
      if (Options.OnError) {
        Options.OnError(err)
      }
      throw err
    }
  }

  /**
   * 取消Http请求
   */
  const Cancel = () => {
    Source?.cancel()
  }

  const HttpGet = async (Url: string, params?: P, config?: AxiosRequestConfig): Promise<R> => {
    return GetResponse(
      await axios.get<R>(Url, {
        params: { ...params, origin: window.location.origin },
        ...config,
        cancelToken: Source?.token,
      }),
    )
  }

  const HttpPost = async (Url: string, params?: P, config?: AxiosRequestConfig): Promise<R> => {
    const newUrl =
      Url.indexOf('?') !== -1 ? `${Url}&origin=${window.location.origin}` : `${Url}?origin=${window.location.origin}`
    return GetResponse(await axios.post<R>(newUrl, params, { ...config, cancelToken: Source?.token }))
  }

  const GetResponse = <T>(Response: AxiosResponse<T>): T => {
    if (Response.headers['content-type'] === 'application/json') {
      return Response.data
    }
    return Response.data
  }
  return { Execute, Cancel }
}

export default BaseHttp
